import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import viewIcon from 'images/icons/invite/view.svg';
import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';
import Tooltip from 'components/ui/Tooltip';

import { useContext } from 'components/Admin/Webinars/Context';
import ViewModal from 'components/Admin/Webinars/Views/Show/Modal';
import EditModal from 'components/Admin/Webinars/Views/Edit/Modal';

export default function Actions({ row }) {
  const { dispatch, actions } = useContext();

  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const deleteWebinar = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this webinar?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin" style="width: 26px"></i>';
          actions.delete(dispatch, row.id);
        }
      },
    );
  };

  return (
    <div>
      <Button
        bsStyle="link"
        className="pl0 pr0 mr5"
        onClick={() => setShowViewModal(true)}
        data-tip="View Details"
      >
        <img src={viewIcon} alt="view details" />
      </Button>

      <Button
        bsStyle="link"
        className="pl0 pr0 mr5"
        onClick={() => setShowEditModal(true)}
        data-tip="Edit"
      >
        <img src={editIcon} alt="edit" />
      </Button>

      <Button
        bsStyle="link"
        className="pl0 pr0"
        onClick={(e) => deleteWebinar(e)}
        data-tip="Delete"
      >
        <img src={deleteIcon} alt="delete" />
      </Button>

      <ViewModal row={row} show={showViewModal} onHide={() => setShowViewModal(false)} />
      <EditModal row={row} show={showEditModal} onHide={() => setShowEditModal(false)} />

      <Tooltip />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
